var render = function render(){var _vm=this,_c=_vm._self._c;return _c('auro-release-card',{staticClass:"auro-release__item",attrs:{"release":_vm.release},on:{"setStatus":_vm.setStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }